module.exports = __webpack_public_path__ + "static/zensite_gray-6c1d90ec4390a6445ff922900490cfde.svg";